import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { BsCart4, BsDisplay } from "react-icons/bs";
import { FaChartPie, FaHome, FaProductHunt, FaUserFriends } from "react-icons/fa";
import { GrBraille, GrPieChart, GrSearch } from "react-icons/gr";
import { RiCustomerService2Line } from "react-icons/ri";
import NavSection from '../components/NavSection';
import { useAuth } from '../hooks/useAuth';
import { useGetStatusQuery } from '../store/indexApi';
import { useGetInquiryQuery } from '../store/inquiryApi';
import { useGetOrdersQuery } from '../store/orderApi';
import { useGetReqsQuery } from '../store/pointApi';
import { useGetQuestionsQuery } from '../store/questionApi';

const BadgeStyle = styled(Badge)({
  '& .MuiBadge-badge': {
    height: '19px',
    right: '-2px'
  }
});

const getOrdersNum = (setOrders) => {
  const { data, error } = useGetOrdersQuery('order', {
    pollingInterval: 60000,
    skipPollingIfUnfocused: true,
  });

  useEffect(() => {
    data && setOrders(data.data)
  }, [data]);
}

const getShingoNum = (setOrders) => {
  const { data, error } = useGetOrdersQuery('shingo', {
    pollingInterval: 60000,
    skipPollingIfUnfocused: true,
  });

  useEffect(() => {
    data && setOrders(data.data)
  }, [data]);
}

const getQuestionNum = (setQuestions) => {
  const { data, error } = useGetQuestionsQuery({
    pollingInterval: 60000,
    skipPollingIfUnfocused: true,
  });

  useEffect(() => {
    data && setQuestions(data.data)
  }, [data]);
}

const getInquiryNum = (setInquiry) => {
  const { data, error } = useGetInquiryQuery({
    pollingInterval: 60000,
    skipPollingIfUnfocused: true,
  });

  useEffect(() => {
    data && setInquiry(data.data)
  }, [data]);
}

const getPointReqNum = (setPointReq) => {
  const { data, error } = useGetReqsQuery({
    pollingInterval: 60000,
    skipPollingIfUnfocused: true,
  });

  useEffect(() => {
    data && setPointReq(data.data)
  }, [data]);
}

const getStatusIndex = (setStatus) => {
  const { data, error } = useGetStatusQuery();

  const _colormap = {
    'green': 'success',
    'yellow': 'warning',
    'red': 'error',
  };

  useEffect(() => {
    data && setStatus(_colormap[data.data] ?? 'info')
  }, [data]);
}

const MenuNavigation = () => {  
  const [orders, setOrders] = useState(0);
  const [shingo, setShingo] = useState(0);
  const [questions, setQuestions] = useState(0);
  const [inquiry, setInquiry] = useState(0);
  const [pointReq, setPointReq] = useState(0);
  const [status, setStatus] = useState('success');
  const auth = useAuth();

  const isAdmin = auth.user && auth.user.role === 'ROLE_ADMIN';

  getStatusIndex(setStatus);
  getOrdersNum(setOrders);
  getShingoNum(setShingo);
  getQuestionNum(setQuestions);
  getInquiryNum(setInquiry);
  getPointReqNum(setPointReq);

  const navigation = [
    {
      id: 'dashboard',
      title: 'dashboard',
      collapse: false,
      path: '/admin/dashboard',    
      icon: <FaChartPie size="22" />
    },
    {
      id: 'store',
      title: '상점관리',
      collapse: false,
      icon: <FaHome size="22" />,
      children: [
        {
          id: '사이트관리',
          title: '사이트관리',
          path: '/admin/shop/site',
        },
        {
          id: '쇼핑몰관리',
          title: '쇼핑몰관리',
          path: '/admin/shop/mall',
        }
      ]
    },
    {
      id: 'front',
      title: '프론트관리',
      collapse: false,
      icon: <BsDisplay size="22" />,
      children: [
        {
          id: '카테고리 관리',
          title: '카테고리 관리',
          path: '/admin/category',
        },
        {
          id: '메인배너 관리',
          title: '메인배너 관리',
          path: '/admin/mainbanner',
        },
        {
          id: '메인카테고리 관리',
          title: 'Key Products 관리',
          path: '/admin/maincategory',
        },
        {
          id: '팝업관리',
          title: '팝업관리',
          path: '/admin/popup',
        },
        {
          id: 'FollowUS 관리',
          title: 'FollowUS 관리',
          path: '/admin/followus',
        },
        {
          id: '카탈로그 관리',
          title: '카탈로그 관리',
          path: '/admin/catalog',
        },
        {
          id: '커뮤니티 관리',
          title: '커뮤니티 관리',
          path: '/admin/community',
        }
      ]
    },
    {
      id: 'service',
      title: '서비스관리',
      collapse: false,
      icon: <GrBraille size="22" />,
      children: [
        {
          id: '이벤트관리',
          title: '이벤트관리',
          path: '/admin/event',
        },
        {
          id: '포인트관리',
          title: '포인트관리',
          path: '/admin/point',
        },
        {
          id: '쿠폰발급',
          title: '쿠폰발급',
          path: '/admin/coupon',
        },
        {
          id: '쿠폰등록',
          title: '쿠폰등록',
          path: '/admin/couponuse',
        },
        {
          id: '상품권관리',
          title: '상품권관리',
          path: '/admin/giftshop',
        },
        {
          id: '상품권신청',
          title:
            <BadgeStyle 
              color="warning"
              showZero
              badgeContent={pointReq}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              >
                상품권신청
            </BadgeStyle>,
          path: '/admin/giftreq',
        },
      ]
    },
    {
      id: 'searchengine',
      title: 
        <Badge  
          color={status}
          variant="dot"
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          >
            검색엔진 관리
        </Badge>,
      collapse: false,
      path: '/admin/search',
      icon: <GrSearch size="22" />,    
    },
    {
      id: 'statistics',
      title: '매출통계',
      collapse: false,
      path: '/admin/stat',
      icon: <GrPieChart size="22" />,    
    },
    {
      id: 'members',
      title: '회원관리',
      collapse: false,
      icon: <FaUserFriends size="22" />,
      children: [
        {
          id: '일반회원',
          title: '일반회원',
          path: '/admin/member',
        },
        isAdmin ? {
            id: '직원관리',
            title: 'Staff',
            path: '/admin/staff',
          }
        : null,
        {
          id: '활동이력',
          title: '활동이력',
          path: '/admin/activity',
        },
        {
          id: '고객사맵',
          title: '고객사맵',
          path: '/admin/map',
        },
        {
          id: '리드',
          title: '리드(잠재고객)',
          path: '/admin/lead',
        },
      ].filter(Boolean), // Filter out null or false values
    },
    {
      id: 'products',
      title: '제품관리',
      collapse: false,
      icon: <FaProductHunt size="22" />,
      children: [
        {
          id: '카테고리',
          title: '카테고리',
          path: '/admin/product/category',
        },
        {
          id: '상품관리',
          title: '상품관리',
          path: '/admin/product/item',
        },
        {
          id: '입고알림 관리',
          title: '입고알림 관리',
          path: '/admin/product/booking',
        },
        {
          id: '문서 관리',
          title: '문서 관리',
          path: '/admin/product/document',
        }
      ]
    },
    {
      id: 'orders',
      title: '주문관리',
      collapse: false,
      icon: <BsCart4 size="22" />,
      children: [        
        {
          id: '견적',
          title: '견적',
          path: '/admin/process/spec',
        },
        {
          id: '주문관리',
          title: 
            <BadgeStyle 
              color="error"
              showZero
              badgeContent={orders}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              >
                주문관리
            </BadgeStyle>,
          path: '/admin/process/ordermanage',
        },
        {
          id: '신고관리',
          title: 
            <BadgeStyle 
              color="error"
              showZero
              badgeContent={shingo}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              >
                신고관리
            </BadgeStyle>,
          path: '/admin/process/shingo',
        },        
        {
          id: '통합주문',
          title: '통합주문',
          path: '/admin/process/order',
        },
        {
          id: '회계관리',
          title: '회계관리',
          path: '/admin/process/account',
        }
      ]
    },
    {
      id: 'cs',
      title: '고객센터',
      collapse: false,
      icon: <RiCustomerService2Line size="22" />,
      children: [
        {
          id: '빠른문의',
          title:
            <BadgeStyle 
              color="info"
              showZero
              badgeContent={inquiry}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              >
                빠른문의
            </BadgeStyle>,
          path: '/admin/inquiry',
        },
        {
          id: '문의',
          title:
            <BadgeStyle 
              color="info"
              showZero
              badgeContent={questions}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              >
                문의
            </BadgeStyle>,
          path: '/admin/question',
        },
        {
          id: '리뷰',
          title: '리뷰',
          path: '/admin/review',
        },
        {
          id: '공지',
          title: '공지',
          path: '/admin/notice',
        },
        {
          id: 'FAQ',
          title: 'FAQ',
          path: '/admin/faq',
        }
      ]
    },
  ];

  return (
    <NavSection navigation={navigation} sx={{pr:1, pb:4, mt: 2}}/>
  )
}

export default MenuNavigation;
